<script setup>
import { computed, defineEmits, defineProps, ref, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: 'Мама, с Днем Победы!',
  },
  show: {
    type: Boolean,
    default: false,
  },
});

const whom = ref(props.modelValue)

const emits = defineEmits(['update:modelValue', 'close']);
const openSelect = ref(false);

function onClose() {
  emits('close');
}

const fireworkFor = {
  '_mama': 'Мама, с Днем Победы!',
  '_papa': 'Папа, с Днем Победы!',
  '_my_dear': 'Мои дорогие, с Днем Победы!',
  '_grandpa': 'Дедушка, с Днем Победы!',
  '_grandma': 'Бабушка, с Днем Победы!',
  '_with_day': 'С Днем Победы!',
  '_friends': 'Друзья, с Днем Победы!',
}

const data = computed(() => [
  '_mama',
  '_papa',
  '_my_dear',
  '_grandpa',
  '_grandma',
  '_with_day',
  '_friends',
].filter((value) => value !== whom.value));

function onSelectWhom(w) {
  openSelect.value = false;
  whom.value = w;
}

function onSelect() {
  emits('update:modelValue', whom.value)
}

watch(() => props.modelValue, (state) => {
  document.body.style.overflowY = state ? 'hidden' : 'visible';
}, { immediate: true });
</script>

<template>
  <Transition name="fade">
    <div v-if="show" class="shell">
      <div class="modal">
        <div class="modal-content">
          <div class="caption">
            <p class="title fw-7">Выберите кого хотите поздравить?</p>
            <button class="close" @click="onClose">
              <svg class="close__img" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_7509_946)">
                  <rect width="21" height="21" rx="10.5" fill="white" />
                  <path d="M10.5 0C4.65 0 0 4.65 0 10.5C0 16.35 4.65 21 10.5 21C16.35 21 21 16.35 21 10.5C21 4.65 16.35 0 10.5 0ZM14.55 15.75L10.5 11.7L6.45 15.75L5.25 14.55L9.3 10.5L5.25 6.45L6.45 5.25L10.5 9.3L14.55 5.25L15.75 6.45L11.7 10.5L15.75 14.55L14.55 15.75Z" fill="#5D6C85" />
                </g>
                <defs>
                  <clipPath id="clip0_7509_946">
                    <rect width="21" height="21" rx="10.5" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
          <!-- <p class="text">
            Описание. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p> -->
          <div class="select-wrapper">
            <p class="select__title">Выберите из списка</p>
            <div class="select">
              <button class="select__button" @click="openSelect = !openSelect">
                  {{ fireworkFor[whom] }}
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18 9.5L12 15.5L6 9.5H18Z"
                    fill="#A5B7CA"
                    stroke="#A5B7CA"
                    stroke-width="2"
                    stroke-linejoin="round" />
                </svg>
              </button>
              <div
                class="select-list"
                :class="{'select-list--open': openSelect}">
                <button
                  v-for="w in data"
                  :key="w"
                  class="select-list__button"
                  @click="onSelectWhom(w)"
                >
                  {{ fireworkFor[w] }}
                </button>
              </div>
            </div>
          </div>

          <button class="link-default" @click="onSelect">Выбрать</button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.shell {
 background: #00288c;
  z-index: 1000000;
}

.modal {
  padding: 0;
  max-width: 562px;
  border-radius: 40px;
  pointer-events: all;
  backdrop-filter: blur(8px);
  background: rgba(157, 196, 248, 0.3);
  padding: 24px;
  width: 100%;

  &-content {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
  }
  @media (max-width:1000px) {
    padding: 16px;
    &-content {
      padding: 16px;
    }
  }
}

.title {
  font-weight: 700;
  font-size: 24px;
  letter-spacing: -0.01em;
  color: #000;
}
.text {
  margin-top: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.6);
}

.fw-7 {
  font-weight: 700;
}

.caption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.close {
  display: flex;
  background: none;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;

  &:hover {
    opacity: 0.5;
  }

  img {
    width: 100%;
  }
}

.red {
  color: #b72025;
}
.link-default {
  margin-top: 16px;
}

.select {
  margin-top: 8px;
  position: relative;

  &-wrapper {
    margin-top: 8px;
  }

  &__title {
    font-weight: 500;
    font-size: 16px;
    line-height: 156%;
    letter-spacing: 0.03em;
    color: #000;
  }
  &__button {
    background: #fff;
    border: 1px solid #a5b7ca;
    border-radius: 8px;
    font-size: 14px;
    line-height: 143%;
    letter-spacing: -0.01em;
    color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 16px;
  }
  &-list {
    position: absolute;
    scrollbar-width: thin;
    border: 1px solid #a5b7ca;
    border-radius: 8px;
    color: rgba(0, 0, 0, 0.6);
    flex-direction: column;
    max-width: 100%;
    width: 100%;
    z-index: 3;
    opacity: 0;
    transition: all 0.5s ease-in-out;
    background: unset;
    padding-bottom: 0;
    max-height: 7rem;
    overflow: auto;
    pointer-events: none;
    display: flex;
    width: 100%;
    background: #fff;
    &--open {
      opacity: 1;
      pointer-events: all;
    }

    &__button {
      width: 100%;
      transition: all 0.5s ease-in-out;
      color: #aeafb1;
      border-bottom: 1px solid #a5b7ca;
      font-size: 14px;
      text-align: left;
      line-height: 120%;
      padding: 8px 16px;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }
    }
  }
}

.link-default{
  @media (max-width:1000px) {
    padding:0.625rem 1rem;
    font-size: 0.88rem;
  }
}

@media (max-width: 1300px) {
  .title {
    font-size: 20px;
  }
  .text {
    font-size: 16px;
  }
}
</style>
